export const actionTemplate = (type) => ({ type });

export const authHeaders = (token) => ({ 'Authorization': `Bearer ${token}` });

export const userAndAuthHeaders = (token, userId) => ({ ...authHeaders(token), UserId: userId });